import type { HTMLAttributes } from 'react';

type Variant = 'default' | 'elevated' | 'interactive' | 'ai';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
}

export function Card({ variant = 'default', className, children, ...rest }: CardProps) {
  const cls = variant === 'default' ? 'card' : `card card-${variant}`;
  return (
    <div className={`${cls} ${className ?? ''}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`card-header ${className ?? ''}`.trim()} {...rest}>
      {children}
    </div>
  );
}
export function CardBody({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`card-body ${className ?? ''}`.trim()} {...rest}>
      {children}
    </div>
  );
}
export function CardFooter({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`card-footer ${className ?? ''}`.trim()} {...rest}>
      {children}
    </div>
  );
}
